export const printHeaders = {
  ART: [
    { code: "IMGART", type: "image" },
    { code: "CODART" },
    { code: "ALTART" },
    { code: "NOMART" },
    { code: "EANART" },
    { code: "TIPART", type: "type" },
    { code: "DESART" },
    { code: "URL2ART" },
    { code: "URLART" },
    { code: "FTEART", type: "brand" },
    { code: "EDIART", type: "check" },
    { code: "ENSART", type: "check" },
    { code: "FAMART", type: "cat" },
    { code: "UBIART" },
    { code: "PREPCO", type: "cost" },
    { code: "TAX", type: "tax" },
    { code: "NOTART" },
    { code: "BULART" },
    { code: "WEBART", type: "check" },
    // { code: "UPTART", type: "date" },
    // { code: "FCRART", type: "date" },
    // { code: "FMOART", type: "date" },
    { code: "GPSART" },
    // {code:"CTAART:0
    // {code:"CUSART:""
    // {code:"FECDOC:""
    // {code:"FLLART:null
    // { code: "FORART", type: "check" },
    // {code:"FREART:0
    // {code:"IMGUART:""
    // {code:"MUSART:""
    // {code:"OFEART:{}
    // {code:"OTRART:0
    // { code: "SERART", type: "type" },
  ],
  PRO: [
    { code: "CODPRO" },
    { code: "RUCPRO" },
    { code: "NOMPRO" },
    { code: "FISPRO" },
    { code: "STAPRO", type: "status" },
    { code: "NACPRO", type: "date" },
    { code: "GENPRO", type: "sex" },
    { code: "GRUPRO", type: "group" },
    { code: "TELPRO" },
    { code: "CELPRO" },
    { code: "EMA1PRO" },
    { code: "EMA2PRO" },
    { code: "EMA3PRO" },
    { code: "EMA4PRO" },
    { code: "DOMPRO", type: "address" },
    { code: "CCOPRO" },
    { code: "CONPRO" },
    { code: "ADJPRO", type: "check" },
    { code: "CREPRO", type: "date" },
    { code: "SINPRO" },
  ],
  CLI: [
    { code: "CODCLI" },
    { code: "NOMCLI" },
    { code: "AGECLI" },
    { code: "CCOCLI" },
    { code: "CELCLI" },
    { code: "CNTCLI" },
    { code: "CONCLI" },
    { code: "CRECLI" },
    { code: "DOMCLI", type: "group" },
    { code: "EMA1CLI" },
    { code: "EMA2CLI" },
    { code: "EMA3CLI" },
    { code: "EMA4CLI" },
    { code: "FACCLI" },
    { code: "FISCLI" },
    { code: "GENCLI", type: "sex" },
    { code: "GRUCLI" },
    { code: "NACCLI" },
    { code: "POLCLI" },
    { code: "PSECLI" },
    { code: "RUCCLI" },
    { code: "RUTCLI" },
    { code: "SINCLI" },
    { code: "STACLI" },
    { code: "TARCLI" },
    { code: "TELCLI" },
    { code: "WEBCLI" },
    { code: "ADJCLI" },
  ],
  PED: [],
  ENT: [],
  CFA: [],
  DEV: [],
  SAL: [],
  TRA: [],
  COT: [],
  ORD: [],
  PRE: [],
  FAC: [],
  REG: [],
  SEV: [
    { code: "SERSEV" },
    { code: "CODSEV" },
    { code: "FECSEV" },
    { code: "FEC2SEV" },
    { code: "CLISEV" },
    { code: "NOMSEV" },
    { code: "TELSEV" },
    { code: "EMASEV" },
    { code: "DOMSEV" },
    { code: "AGESEV" },
    { code: "ANOSEV" },
    { code: "CELSEV" },
    { code: "CRESEV" },
    { code: "CNOSEV" },
    { code: "GARSEV" },
    { code: "EST1SEV" },
    { code: "EST2SEV" },
    { code: "EST3SEV" },
    { code: "ENVSEV" },
    { code: "WEBSEV" },
    { code: "PAGSEV" },
    { code: "TALSEV" },
    { code: "POLSEV" },
    { code: "PSESEV" },
    { code: "INTSEV" },
    { code: "INTNSEV" },
    { code: "PIMSEV" },
    { code: "PRESEV" },
    { code: "PCOSEV" },
    { code: "NETSEV" },
    { code: "DESSEV" },
    { code: "IMPSEV" },
    { code: "TOTSEV" },
    { code: "ABOSEV" },
    { code: "SALSEV" },
    { code: "NOTSEV" },
    { code: "OBSSEV" },
    // { code: "RECSEV" },
    { code: "RNOSEV" },
    // { code: "RESSEV" },
    { code: "NRSSEV" },
    { code: "ADJSEV" },
    { code: "GPSSEV" },
    // { code: "ABRSEV" },
    // { code: "ALMSEV" },
    // { code: "CADSEV" },
    // { code: "FISSEV" },
    // { code: "INCSEV" },
    // { code: "RELSEV" },
    // { code: "NABSEV" },
    // { code: "NVOSEV" },
    // { code: "PAISEV" },
    // { code: "PASSEV" },
    // { code: "PSESEV" },
    // { code: "POSSEV" },
    // { code: "UMOSEV" },
    // { code: "USUSEV" },
  ],
};
